module.exports = __webpack_public_path__ + "img/afghanistan.e287a0c3.svg";